import { REPORT_GROUP_TYPE } from 'lib/const/ReportData';
import React from 'react';
import { useTheme } from 'styled-components/macro';
import { ParagraphExtraSmallBold } from '../styles/typography';
import { SingleAvailableField } from './SingleAvailableField';
import { AvailableGroupListProps } from './types';
import { IWhiteLabel, WHITELABEL_NAME } from 'lib/api/whitelabel/getWhiteLabel';
import { useAuth } from 'lib/context';

const getFieldTitle = (name: string, whitelabel: IWhiteLabel) => {
  switch (name) {
    case REPORT_GROUP_TYPE.POPULAR:
      return 'MOST POPULAR';
    case REPORT_GROUP_TYPE.COVIDEO:
      return whitelabel.name === WHITELABEL_NAME.CDK
        ? 'SENDING FROM CRM VIDEO'
        : 'SENDING FROM COVIDEO';
    case REPORT_GROUP_TYPE.SERVICE:
      return 'SERVICE RELATED';
    default:
      return '';
  }
};

export const AvailableGroupFieldsList = ({
  allFields,
  isMaxFieldReached,
  selectedFields,
  onAddClickHandler,
}: AvailableGroupListProps) => {
  const { colors } = useTheme();
  const { whitelabel } = useAuth();
  return (
    <>
      {Object.keys(allFields).map((groupField, idx) => (
        <React.Fragment key={idx}>
          <ParagraphExtraSmallBold
            color={colors.neutral[60]}
            m={idx === 0 ? '0px 0 8px 0' : '16px 0 8px 0'}
            style={{ textTransform: 'uppercase' }}
          >
            {getFieldTitle(groupField, whitelabel)}
          </ParagraphExtraSmallBold>
          {allFields[groupField as REPORT_GROUP_TYPE].map(field => {
            const isSelected = selectedFields.some(
              item => item.value === field.value
            );

            const isSelectionOrMaxReached = isSelected || isMaxFieldReached;
            return (
              <SingleAvailableField
                key={field.value}
                onAddClickHandler={onAddClickHandler}
                isSelectionOrMaxReached={isSelectionOrMaxReached}
                isSelected={isSelected}
                field={field}
              />
            );
          })}
        </React.Fragment>
      ))}
    </>
  );
};
